import React from 'react';
import ButtonActionWrapper from './ButtonActionWrapper';
import ButtonContentWrapper from './ButtonContentWrapper';
import { RadiusPropKeys } from 'src/app/styles/spacing';
export interface ButtonProps {
  children?: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'primary' | 'secondary' | 'tertiary' | 'text-link' | 'brand-text-link';
  icon?: React.ReactNode;
  iconPosition?: 'left' | 'right';
  href?: string;
  className?: string;
  loading?: boolean;
  radius?: RadiusPropKeys;
  decoration?: 'none' | 'underline';
  display?: 'inline' | 'block' | 'flex';
}

const Button = (props: ButtonProps): JSX.Element => {
  const { children, icon, iconPosition, loading, size, radius } = props;

  const isDisabled = props.disabled || loading;

  return (
    <ButtonActionWrapper
      {...props}
      disabled={isDisabled}
      isIconOnly={!!icon && !children}
      radius={radius}
    >
      <ButtonContentWrapper
        icon={icon}
        iconPosition={iconPosition}
        size={size}
      >
        {children}
      </ButtonContentWrapper>
    </ButtonActionWrapper>
  );
};

export default Button;
